module.exports = __webpack_public_path__ + "b145f0e884b2da8f1b112d26e7cefd3d.ttf";


//////////////////
// WEBPACK FOOTER
// ./css/fonts/Fantasque/FantasqueSansMono-Bold.ttf
// module id = 417
// module chunks = 0